<template>
  <v-row>
    <v-col md="8" offset-md="2" xl="6" offset-xl="3">
      <v-alert v-if="message" border="left" type="success" elevation="2">
        {{ message }}
      </v-alert>
      <BaseBlock title="Formulaire de recherche">
        <v-form v-model="valid" ref="form">
          <v-alert
            v-if="error.messages"
            border="left"
            type="error"
            elevation="2"
          >
            <template v-for="(errorMessage, index) in error.messages">
              <span :key="index">
                {{ errorMessage }}
                <br />
              </span>
            </template>
          </v-alert>

          <v-row>
            <v-col cols="4">
              <v-text-field
                hint="UID personne, UID compte, ..."
                v-model="recherche.identifiant"
                label="Identifiant"
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="recherche.mail"
                label="Email"
                :rules="mailRules"
                @input="resetApiErrors('mail')"
                :error-messages="checkApiErrors('mail')"
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-menu
                v-model="showCalendar"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formatedDate"
                    label="Date de naissance"
                    prepend-icon="event"
                    readonly
                    clearable
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="fr-fr"
                  v-model="recherche.date"
                  @input="showCalendar = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="recherche.nom"
                label="Nom"
                @input="resetApiErrors('nom')"
                :error-messages="checkApiErrors('nom')"
                :rules="nomRules"
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="recherche.prenom"
                label="Prenom"
                @input="resetApiErrors('prenom')"
                :error-messages="checkApiErrors('prenom')"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="text-center">
                <v-btn
                  class="mx-2"
                  :disabled="!valid"
                  color="primary"
                  @click="rechercher"
                  :loading="loading"
                >
                  <v-icon left>mdi-magnify</v-icon>Rechercher
                </v-btn>
                <v-btn class="mx-2" @click="$refs.form.reset()">
                  <v-icon left>mdi-refresh</v-icon>Effacer
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>

    <v-col v-if="hasResultats" cols="12">
      <BaseBlock title="Résultat de la recherche"
        >Les résultats sont ici !</BaseBlock
      >
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import BaseForm from "@/components/base/BaseForm";
import moment from "moment";

export default {
  name: "Recherche",
  components: { BaseBlock },
  extends: BaseForm,
  data() {
    return {
      recherche: {
        identifiant: "",
        nom: "",
        prenom: "",
        email: "",
        date: "",
      },
      showCalendar: false,
      message: null,
      hasResultats: false,
      loading: false,

      nomRules: [
        (v) => (v && v.length >= 2) || "Nom doit contenir minimum 2 caractères",
      ],
      mailRules: [
        (v) =>
          /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail doit être valide",
      ],
    };
  },
  computed: {
    formatedDate() {
      return this.recherche.date
        ? moment(this.recherche.date).format("DD/MM/YYYY")
        : "";
    },
  },
  created() {
    if (sessionStorage.recherche) {
      this.recherche = JSON.parse(sessionStorage.recherche);
    }
  },
  methods: {
    async rechercher() {
      sessionStorage.recherche = JSON.stringify(this.recherche);
      this.error = {};
      this.loading = true;
      this.message = "";
      this.hasResultats = false;
      try {
       
        await setTimeout(() => {
          this.message = "La recherche a bien été effectué";
          this.hasResultats = true;
          this.loading = false;
        }, 1000);

        /*
        A décommenter pour tester l'affichage des exceptions revenant de l'API
        La gestion de l'exception se gère normalement dans le catch
        errorObject simule l'objet "err" du catch
        */
        /*
        let errorObject = {
          response: {
            data: {
              status: "400",
              path: "/api/recherche",
              messages: [
                "Les objets X et Y doivent être identiques",
                "yyy",
                "zzz"
              ],
              fieldErrors: [
                {
                  field: "nom",
                  message: "la taille doit être comprise entre 2 et 2147483647"
                },
                {
                  field: "prenom",
                  message: "Le champs ne doit pas être nul"
                }
              ],
              timestamp: "25/02/2020 05:32:56"
            }
          }
        };
        this.populateErrors(errorObject);
        */
      } catch (err) {
        this.populateErrors(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
